/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardian_Link_TitleInputs */

const fr_guardian_link_title = /** @type {(inputs: Guardian_Link_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lier un enfant existant`)
};

/**

* @param {Guardian_Link_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const guardian_link_title = /** @type {((inputs?: Guardian_Link_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardian_Link_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_guardian_link_title(inputs)
});